import { palette } from '@dev/ee-components';
import styled from 'styled-components';

export const FilterContainer = styled.div`
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    .optionWithCheckbox,
    .MuiAccordionSummary-root {
        &:hover {
            background: ${palette.indigo[1]};
        }
    }
`;

export const FilterLabel = styled.span`
    margin: 0;
    display: flex;
    align-items: center;
    flex: 1;
    & + .MuiChip-root {
        margin-left: 12px;
    }
`;

export const EventFilterWrapper = styled.div`
    & .optionTag {
        margin: 12px 48px 12px 0;
    }
    .optionWithCheckbox,
    .MuiAccordionSummary-root {
        &:hover {
            background: ${palette.indigo[1]};
        }
    }
`;
